import { connect } from '@atlassian/jira-react-redux';
import { get as getAnalyticsData } from '../../state/analytics/selectors';
import { isAdmin } from '../../state/context/selectors';
import type { State } from '../../state/reducer';
import { initiate as initiateAddComponent } from '../../state/ui/add/actions';
import EmptyPlaceholderView from './view';

const mapStateToProps = (state: State) => ({
	analyticsData: getAnalyticsData(state),
	canAddComponent: isAdmin(state),
});

const mapDispatchToProps = {
	onAddComponent: initiateAddComponent,
} as const;

export default connect(mapStateToProps, mapDispatchToProps)(EmptyPlaceholderView);
